import Divider from '@material-ui/core/Divider';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconArrow } from 'src/assets/icons/IconArrow';
import {
  CUSTOM_ICON_BUTTON_SIZE,
  CUSTOM_ICON_BUTTON_VARIANT,
  CustomIconButton,
} from 'src/components/CustomIconButton';
import { CustomTooltip } from 'src/components/CustomTooltip';

import { WIDGET_ACTION } from '../../lib';

import { EditorTypeDropdown } from './components/EditorTypeDropdown/EditorTypeDropdown';
import { useStyles } from './useStyles';

export const PromptFooterActions = ({
  className,
  onAction,
  disabled,
  loading,
  allowedSubmit,
  uploadingResources,
  onEditorChange,
  editorType,
}) => {
  const styles = useStyles();

  return (
    <div
      className={cx(styles.root, className, {
        [styles.allowedSubmit]: allowedSubmit,
      })}
    >
      <EditorTypeDropdown
        onChange={onEditorChange}
        editorType={editorType}
      />
      <Divider
        className={styles.divider}
        orientation="horizontal"
      />
      <CustomTooltip title={uploadingResources ? 'Upload in progress' : ''}>
        <span>
          <CustomIconButton
            className={styles.buttonSubmit}
            onClick={() => onAction(WIDGET_ACTION.submit)}
            disabled={disabled || uploadingResources || !allowedSubmit}
            loading={loading}
            variant={CUSTOM_ICON_BUTTON_VARIANT.primary}
            size={CUSTOM_ICON_BUTTON_SIZE.large}
          >
            <IconArrow className={styles.iconSubmit} />
          </CustomIconButton>
        </span>
      </CustomTooltip>
    </div>
  );
};

PromptFooterActions.propTypes = {
  className: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

PromptFooterActions.defaultProps = {
  className: null,
  disabled: false,
  loading: false,
};
